const rawBaseUrl = import.meta.env.VITE_API_URL ?? "";

const normalisedBaseUrl = rawBaseUrl.trim().replace(/\/+$/, "") || "";

export const API_BASE_URL = normalisedBaseUrl;

export const buildApiUrl = (path: string) => {
    const normalisedPath = path.startsWith("/") ? path : `/${path}`;

    if (!API_BASE_URL) {
        return normalisedPath;
    }

    if (
        API_BASE_URL.endsWith("/api") &&
        normalisedPath.toLowerCase().startsWith("/api/")
    ) {
        return `${API_BASE_URL}${normalisedPath.slice(4)}`;
    }

    return `${API_BASE_URL}${normalisedPath}`;
};
